(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__cartDrawerInit) return;
    window.__cartDrawerInit = true;

    var drawer, panel, itemsEl, emptyEl, footEl, subtotalEl, lastFocus;
    var CURRENCY, CART_URL, CHANGE_URL;

    // ponytail: Intl handles standard currencies; stores with fully custom
    // money_format strings would need Shopify.formatMoney instead.
    function money(cents) {
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: CURRENCY,
        }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    }

    function els() {
      drawer = document.querySelector('[data-cart-drawer]');
      if (!drawer) return false;
      CURRENCY = drawer.getAttribute('data-currency');
      CART_URL = drawer.getAttribute('data-cart-url');
      CHANGE_URL = drawer.getAttribute('data-cart-change-url');
      panel = drawer.querySelector('.cd__panel');
      itemsEl = drawer.querySelector('[data-cart-items]');
      emptyEl = drawer.querySelector('[data-cart-empty]');
      footEl = drawer.querySelector('[data-cart-foot]');
      subtotalEl = drawer.querySelector('[data-cart-subtotal]');
      return true;
    }

    function setCount(n) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = n;
      });
    }

    function render(cart) {
      setCount(cart.item_count);
      if (subtotalEl) subtotalEl.textContent = money(cart.total_price);

      var empty = cart.item_count === 0;
      if (emptyEl) emptyEl.hidden = !empty;
      if (footEl) footEl.style.display = empty ? 'none' : '';

      itemsEl.innerHTML = cart.items
        .map(function (item) {
          var img = item.image
            ? '<img class="cd__item-img" src="' +
              item.image.replace(/(\.[a-z]+)(\?|$)/i, '_176x$1$2') +
              '" alt="" width="88" height="88">'
            : '<span class="cd__item-img"></span>';
          var variant =
            item.variant_title && item.variant_title !== 'Default Title'
              ? '<p class="cd__item-variant">' + item.variant_title + '</p>'
              : '';
          return (
            '<div class="cd__item" data-key="' + item.key + '">' +
            img +
            '<div>' +
            '<a class="cd__item-title" href="' + item.url + '">' + item.product_title + '</a>' +
            variant +
            '<span class="cd__qty">' +
            '<button type="button" data-qty-dec aria-label="Decrease quantity">−</button>' +
            '<span data-qty>' + item.quantity + '</span>' +
            '<button type="button" data-qty-inc aria-label="Increase quantity">+</button>' +
            '</span>' +
            '</div>' +
            '<div class="cd__item-end">' +
            '<span class="cd__item-price">' + money(item.final_line_price) + '</span>' +
            '<button type="button" class="cd__remove" data-remove>Remove</button>' +
            '</div>' +
            '</div>'
          );
        })
        .join('');
    }

    function refresh(andOpen) {
      return fetch(CART_URL, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          render(cart);
          if (andOpen) open();
          return cart;
        });
    }

    function change(key, quantity) {
      return fetch(CHANGE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity }),
      })
        .then(function (r) { return r.json(); })
        .then(render);
    }

    function open() {
      if (!drawer) return;
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      // Compensate for the vanishing scrollbar so the page doesn't shift.
      var sbw = window.innerWidth - document.documentElement.clientWidth;
      if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
      document.body.style.overflow = 'hidden';
      if (panel) panel.focus();
    }

    function close() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function init() {
      if (!els()) return;

      // Open triggers (header + home cart links).
      document.addEventListener('click', function (e) {
        var toggle = e.target.closest('[data-cart-toggle]');
        if (toggle) {
          e.preventDefault();
          refresh(true);
          return;
        }
        if (e.target.closest('[data-cart-close]')) {
          e.preventDefault();
          close();
        }
      });

      // Item quantity / remove (event-delegated on the drawer).
      itemsEl.addEventListener('click', function (e) {
        var row = e.target.closest('.cd__item');
        if (!row) return;
        var key = row.getAttribute('data-key');
        var qtyEl = row.querySelector('[data-qty]');
        var qty = parseInt(qtyEl ? qtyEl.textContent : '1', 10) || 1;
        if (e.target.closest('[data-remove]')) return change(key, 0);
        if (e.target.closest('[data-qty-inc]')) return change(key, qty + 1);
        if (e.target.closest('[data-qty-dec]')) return change(key, Math.max(0, qty - 1));
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
      });

      // Product add-to-cart fires this; open the drawer with fresh contents.
      document.addEventListener('cart:added', function (e) {
        if (e.detail && e.detail.item_count != null) {
          render(e.detail);
          open();
        } else {
          refresh(true);
        }
      });
    }

    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
